import { Typography } from 'antd'

import { FieldTextProps } from '../../interface'

export const FieldText = ({
  className,
  style,
  secondary,
  sucess,
  warning,
  danger,
  value
}: FieldTextProps) => {
  return (
    <Typography.Text
      className={className}
      style={style}
      type={
        secondary
          ? 'secondary'
          : sucess
            ? 'success'
            : warning
              ? 'warning'
              : danger
                ? 'danger'
                : undefined
      }
    >
      {value}
    </Typography.Text>
  )
}
